exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.jcy-default-layout {\n  width: 100%;\n  height: 100%;\n}\n.jcy-default-layout .jcy-main-wrapper {\n    width: 100%;\n    min-height: 100%;\n    padding-bottom: 13.33333vw;\n}\n", "", {"version":3,"sources":["F:/develop/JCeshop-wx/src/components/layout/default-layout.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;CACd;AACD;IACI,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;CAC9B","file":"default-layout.vue","sourcesContent":["\n.jcy-default-layout {\n  width: 100%;\n  height: 100%;\n}\n.jcy-default-layout .jcy-main-wrapper {\n    width: 100%;\n    min-height: 100%;\n    padding-bottom: 13.33333vw;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a0d49b0","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/default-layout.vue
// module id = 6fIm
// module chunks = 83